import React, { Component } from 'react';
import {connect}                 from 'react-redux';
import $ from 'jquery';
import { GetRanckingTop }   from '../../../actions/talentosAction';
import {SetError}                   from '../../../actions/notificacaoAction';


class feeds_big extends Component {

    constructor(props){

        super(props);

        this.state = {

            posicao0:{posicao:null,pontos:null,nome:null,status:null,talento:"O(a) Obstinado(a)"},
            posicao1:{posicao:null,pontos:null,nome:null,status:null,talento:"O(a) Obstinado(a)"},
            posicao2:{posicao:null,pontos:null,nome:null,status:null,talento:"O(a) Obstinado(a)"},
            posicao3:{posicao:null,pontos:null,nome:null,status:null,talento:"O(a) Obstinado(a)"},
            posicao4:{posicao:null,pontos:null,nome:null,status:null,talento:"O(a) Obstinado(a)"},
            actionAnimate:false

        }
    }

    componentDidMount() { 
        var cont = 0;   
           
        setInterval(() => {
            $('.feed-header-'+cont).fadeOut();
            $('.feed-pontos-'+cont).fadeOut();
            $('.feed-talentos-'+cont).fadeIn("slow");
            $('.feed-header-'+cont).fadeIn("slow");
            var a = cont -1;
            $('.feed-pontos-'+a).fadeIn("slow");
            $('.feed-talentos-'+a).fadeOut();
          if (cont === 4) {
              cont = 0;  
          }else{
            cont++;
          }
        
         
        },10000);
        
    }

    componentWillMount(){

        this.props.GetRanckingTop(this.props.session.id,this.props.session.turma).then((response)=>{
            const data = response.payload.data;
            if (data.length>0) {
                data.map((elem,i)=>{
                    this.setState({[`posicao${i}`]:{
                        posicao:elem.posicao,
                        pontos:`${elem.pon_ger_pontos} Pts`,
                        nome:elem.use_nome.split(" ")[0],
                        status:(elem.use_id == this.props.session.id ?true:false),
                        talento:elem.titulo
                       }
                    });    
                });
            }       
          
          }).catch((error)=>{
            this.props.SetError(500);
          });     
    }
    
    render(){

        const opa = {'opacity':'0'}
   
        return (
            <div className="feeds big">
                <div className="feeds-columns feeds-columns-center">
                    <div className="feeds-column">
                        <div className="feed feed-opacity-20"></div>
                        <div className={this.state.posicao1.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header feed-header-1">{this.state.posicao1.nome}</div>
                            <div className="feed-body">
                                <div className="feed-pontos-1">{this.state.posicao1.pontos}</div>
                                <div className="feed-talentos-1">{this.state.posicao1.talento}</div>
                            </div>
                            {this.state.posicao1.pontos?   <div className="feed-label feed-label-bottom-left"><div className="feed-label-value">{this.state.posicao1.posicao}º</div></div>:""} 
                        </div>
                        <div className="feed feed-opacity-20"></div>
                    </div>
                    <div className="feeds-column">
                       
                         <div className={this.state.posicao2.status? 'feed basic active active-40': 'feed basic'}>  
                         
                             <div className="feed-header feed-header-2">{this.state.posicao2.nome}</div>
                            <div className="feed-body">
                                <div className="feed-pontos-2">{this.state.posicao2.pontos}</div>
                                <div className="feed-talentos-2">{this.state.posicao2.talento}</div>
                            </div>
                            {this.state.posicao2.pontos?  
                                <div className="feed-label">
                                    <div className="feed-label-value">
                                       {this.state.posicao2.posicao}º
                                    </div>
                                </div> 
                             : ""}
                        
                        </div>
                        
                        <div className="feed feed-opacity-20"></div>
                        <div className={this.state.posicao0.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header feed-header-0">{this.state.posicao0.nome}</div>
                            <div className="feed-body">
                                <div className="feed-pontos-0">{this.state.posicao0.pontos}</div>
                                <div className="feed-talentos-0">{this.state.posicao0.talento}</div>
                            </div>
                            {this.state.posicao0.pontos ?  <div className="feed-label active">
                                <div className="feed-label-value">
                                  {this.state.posicao0.posicao}º
                                </div>
                            </div>
                            :""}
                        </div>
                    </div>
                    <div className="feeds-column">
                        <div className="feed feed-opacity-20" style={opa}></div>
                        <div className={this.state.posicao3.status? 'feed basic active active-40': 'feed basic'}>
                            <div className="feed-header feed-header-3">{this.state.posicao3.nome}</div>
                            <div className="feed-body">
                                <div className="feed-pontos-3">{this.state.posicao3.pontos}</div>
                                <div className="feed-talentos-3">{this.state.posicao3.talento}</div>
                            </div>
                            {this.state.posicao3.pontos ?  <div className="feed-label feed-label-top-right">
                                <div className="feed-label-value">
                                {this.state.posicao3.posicao}º
                                </div>
                            </div>:""}
                        </div>
                        <div className="feed feed-opacity-20"></div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {

    return {session: state.auth.session};
}

export default connect(mapStateToProps, {GetRanckingTop,GetRanckingTop,SetError})(feeds_big);



// WEBPACK FOOTER //
// ./src/components/aluno/home/feeds_rancking_aluno.js